import axios from 'api/axiosController';
import { getAccessToken } from "utils/auth";


export const getProducts = async (page:number) => {
  let uri = `/admin/products?page=${page}`;
  try {
    const res = await axios.get(uri, { headers: {"Authorization" : `Bearer ${getAccessToken()}`} });
    return res.data;
  } catch (e) {
    throw e;
  }
};
